import { createFileRoute } from "@tanstack/react-router";
import { SEOPage } from "@/components/site/SEOPage";

export const Route = createFileRoute("/quem-somos")({
  head: () => ({
    meta: [
      { title: "Quem Somos - P2 PRO | Líder em Infraestrutura IPTV 2026" },
      { name: "description", content: "Conheça a história da P2 PRO. Somos especialistas em infraestrutura para revendedores de IPTV, focados em estabilidade, tecnologia 4K e suporte premium." },
    ],
  }),
  component: () => (
    <SEOPage
      category="Institucional"
      title="QUEM SOMOS: A P2 PRO E NOSSO COMPROMISSO"
      subtitle="Conheça a empresa que está definindo os novos padrões de qualidade no mercado de streaming brasileiro."
      introParagraphs={[
        "A P2 PRO nasceu da necessidade de profissionalizar o mercado de revenda de conteúdo via streaming no Brasil. Percebemos que muitos revendedores sofriam com servidores instáveis, falta de suporte e tecnologias obsoletas. Decidimos, então, criar uma infraestrutura que fosse, acima de tudo, confiável.",
        "Com anos de experiência em engenharia de redes e transmissão de dados, nossa equipe desenvolveu um ecossistema completo que hoje atende milhares de parceiros em todo o território nacional. Investimos pesado em servidores de alta performance (Tier 3) e rotas de CDN exclusivas para garantir que o sinal chegue com perfeição ao cliente final.",
        "Nosso objetivo não é ser apenas o maior servidor, mas sim o melhor parceiro para o seu negócio. Acreditamos que o sucesso do nosso revendedor é o nosso próprio sucesso, e é por isso que trabalhamos 24 horas por dia para manter a excelência que o nome P2 PRO representa."
      ]}
      benefits={[
        {
          title: "Transparência Total",
          description: "Relacionamento claro e honesto com nossos parceiros e clientes.",
        },
        {
          title: "Inovação Constante",
          description: "Sempre na vanguarda das tecnologias de compressão e entrega de sinal.",
        },
        {
          title: "Foco no Cliente",
          description: "Tudo o que desenvolvemos é pensado na melhor experiência de uso final.",
        }
      ]}
      howItWorks={[
        { title: "Nossa Missão", description: "Democratizar o acesso ao entretenimento de alta qualidade com preço justo." },
        { title: "Nossa Visão", description: "Ser a maior e mais estável rede de distribuição de conteúdo digital da América Latina." },
        { title: "Nossos Valores", description: "Ética, estabilidade tecnológica e compromisso com o resultado do parceiro." },
        { title: "Onde Estamos", description: "Operação global com foco no mercado brasileiro e suporte 100% em português." }
      ]}
      diferenciais={[
        { title: "Engenharia Própria", description: "Não somos apenas revendedores, desenvolvemos nossas próprias soluções de rede." },
        { title: "Atendimento Humanizado", description: "Aqui você não fala com robôs, fala com especialistas que entendem seu negócio." },
        { title: "Solidez no Mercado", description: "Anos de operação contínua sem interrupções, garantindo segurança para seu investimento." }
      ]}
      faq={[
        {
          question: "A P2 PRO é confiável?",
          answer: "Sim, somos referência no mercado com milhares de revendedores ativos e anos de operação ininterrupta."
        },
        {
          question: "Qual o diferencial da P2 PRO para outros servidores?",
          answer: "Nossa infraestrutura própria de CDN e nosso compromisso real com a estabilidade em horários de pico."
        },
        {
          question: "Como posso me tornar um parceiro?",
          answer: "Basta entrar em contato com nosso time de consultores através dos botões de WhatsApp espalhados pelo site."
        }
      ]}
      breadcrumbs={[
        { label: "Institucional", href: "/" },
        { label: "Quem Somos", href: "/quem-somos" }
      ]}
    />
  ),
});
